// 入口函数，在页面加载完成后执行
function main() {
  Alpine.data('tipsBar', function () {
    const items = this.$el.querySelectorAll(".el-carousel__item")

    return {
      // 当前激活的项
      active: 0,
      len: items.length,
      timer: null,

      init() {
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null
        }

        this.timer = setInterval(() => {
          this.next()
        }, 3000)
      },

      next() {
        this.active = (this.active + 1) % this.len
      },

      getItemHeight() {
        var item = document.querySelector(".el-carousel__item")
        return item.clientHeight
      },

      getItemStyle(index) {
        if (index === this.active) {
          return "transform: translateY(0px) scale(1);"
        }

        // 循环播放
        // 下一项, 超过len第一项补到下一个位置
        if (index === this.active + 1 || (this.active === this.len - 1 && index === 0)) {
          return `transform: translateY(${this.getItemHeight()}px) scale(1);`
        }

        // 上一项, 第一项补到最后一个位置
        if (index === this.active - 1 || (this.active === 0 && index === this.len - 1)) {
          return `transform: translateY(-${this.getItemHeight()}px) scale(1);`
        }

        // 其他项 在下方隐藏
        return `transform: translateY(${this.getItemHeight()}px) scale(0);transition: none;`
      },

      showLanguageDialog() {
        publish(PUB_SUB_EVENTS.languageDialog, {
          data: {
            show: true,
          },
        });
      }
    }
  })
}

document.addEventListener('alpine:init', main)
